import { render, staticRenderFns } from "./AppNotice.vue?vue&type=template&id=54666bea&scoped=true&"
import script from "./AppNotice.vue?vue&type=script&lang=js&"
export * from "./AppNotice.vue?vue&type=script&lang=js&"
import style0 from "./AppNotice.vue?vue&type=style&index=0&id=54666bea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54666bea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})
